<div class="cs-cb-sticky">
  <div class="thinking-indicator">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
</div>

<style lang="scss">
  @use './../../../../scss/components/themes/loading-theme/loading-sticky-theme';
</style>
